import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { crudListToPaginated, toCrudSort } from '@app/modules/audit/utils/audit-matches-crud';
import { auditScheduleAuditSchedulesList } from '@mi-front/api-v2';
import { AuditSchedule } from '@mi-front/core';
import { ListingView } from '../../../../../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../../../../../core/reports/types';
import {
  buildSchedulesListCrudFilters,
  SchedulesListFilterValues,
  schedulesListMetadataDefaultValues,
} from '../../schedules-list-filter';
import { SchedulesListSpotForm } from './SchedulesListSpotForm';
import { SchedulesListSpotResult } from './SchedulesListSpotResult';

interface Props {
  readonly station: Station;
}

export type SchedulesSpotListing = ListingType<SchedulesListFilterValues, AuditSchedule>;

/**
 * Spot schedules listing for a station via api-v2 CRUD schedules list.
 */
export function SchedulesSpotListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<SchedulesSpotListing>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        customId: '',
        ...schedulesListMetadataDefaultValues,
        sort: 'datetime desc',
      }}
      queryParamsTransform={{
        customId: {
          serialize: (input: string) => {
            return input.replace(/\s/g, '');
          },
        },
      }}
      reportFn={async (values) => {
        const res = await auditScheduleAuditSchedulesList({
          station: p.station.slug,
          filter: buildSchedulesListCrudFilters(values, 'SPOT'),
          page: (values.pageIndex ?? 0) + 1,
          limit: values.pageSize,
          sort: toCrudSort(values.sort) ?? ['datetime,DESC'],
          join: ['audio', 'matches'],
        });

        return crudListToPaginated({
          ...res,
          data: res.data as unknown as AuditSchedule[],
        });
      }}
      Form={SchedulesListSpotForm}
      Result={SchedulesListSpotResult}
    />
  );
}
